/**
 * index.js — React application entry point.
 *
 * Mounts the root <App /> component into the #root DOM node (defined in
 * public/index.html) inside <React.StrictMode> for highlighting potential
 * problems during development.
 *
 * Performance monitoring is available via reportWebVitals (currently a no-op
 * — pass a callback like `reportWebVitals(console.log)` to enable).
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DefaultLoadingManager } from 'three';
import { getRuntimeAdapter, isMobileBuild } from './platform';

function mount() {
  if (isMobileBuild) DefaultLoadingManager.setURLModifier(url => getRuntimeAdapter().resolveAsset(url));
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
}
if (isMobileBuild) {
  const adapter = getRuntimeAdapter();
  if (adapter) adapter.ready.then(mount).catch(error => { document.getElementById('root').textContent = `Could not open the device workspace: ${error.message}`; });
  else document.getElementById('root').textContent = 'Open the visualizer from the mobile app.';
} else mount();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
